// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Arvo";
  font-display: fallback;
  src: local("Arvo"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Arvo/Arvo-Regular.ttf");
}
@font-face {
  font-family: "Droid Sans";
  font-display: fallback;
  src: local("Droid Sans"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/droid-sans/DroidSans.ttf");
}
@font-face {
  font-family: "Droid Serif";
  font-display: fallback;
  src: local("Droid Serif"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/droid-serif/DroidSerif-Regular.ttf");
}
@font-face {
  font-family: "Libre Baskerville";
  font-display: fallback;
  src: local("Libre Baskerville"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Libre_Baskerville/LibreBaskerville-Regular.ttf");
}
@font-face {
  font-family: "Merriweather";
  font-display: fallback;
  src: local("Merriweather Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Merriweather/Merriweather-Regular.ttf");
}
@font-face {
  font-family: "Old Standard TT";
  font-display: fallback;
  src: local("Old Standard TT Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Old_Standard_TT/OldStandard-Regular.ttf");
}
@font-face {
  font-family: "Open Sans";
  font-display: fallback;
  src: local("Open Sans Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Open_Sans/OpenSans-Regular.ttf");
}
@font-face {
  font-family: "PT Sans";
  font-display: fallback;
  src: local("PT Sans"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/PT_Sans/PT_Sans-Web-Regular.ttf");
}
@font-face {
  font-family: "Roboto";
  font-display: fallback;
  src: local("Roboto"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Roboto/Roboto-Regular.ttf");
}
@font-face {
  font-family: "Raleway";
  font-display: fallback;
  src: local("Raleway"), url("https://fonts.googleapis.com/css2?family=Raleway&display=swap");
}
@font-face {
  font-family: "Ubuntu";
  font-display: fallback;
  src: local("Ubuntu Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Ubuntu/Ubuntu-Regular.ttf");
}
@font-face {
  font-family: "Vollkorn";
  font-display: fallback;
  src: local("Vollkorn Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Vollkorn/Vollkorn-Regular.ttf");
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
